import { render, staticRenderFns } from "./SettingsFormClass.vue?vue&type=template&id=1eb05752"
import script from "./SettingsFormClass.vue?vue&type=script&lang=js"
export * from "./SettingsFormClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports